// Production/default repository value. Local developers may override this file locally.
const API_BASE_URL = '/api';
export default API_BASE_URL;

